import { useState, useCallback } from "react";

import { Menu, type MenuProps } from "antd";

import { AgentInternalTransfer } from "./AgentTransfer/AgentTransfer";
import { QueueInternalTransfer } from "./QueueTransfer/QueueTransfer";

import styles from "./InternalTransfer.module.scss";

const INTERNAL_TRANSFER_TYPE = {
    AGENT: "Agent",
    QUEUE: "Queue",
} as const;

type InternalTransferType = (typeof INTERNAL_TRANSFER_TYPE)[keyof typeof INTERNAL_TRANSFER_TYPE];

export function InternalTransfer(): JSX.Element {
    const [transferType, setTransferType] = useState<InternalTransferType>(INTERNAL_TRANSFER_TYPE.AGENT);

    const handleClick = useCallback<NonNullable<MenuProps["onClick"]>>(
        (event) => {
            setTransferType(event.key as InternalTransferType);
        },
        [setTransferType]
    );

    return (
        <>
            <Menu
                className={styles.horizontalMenu}
                onClick={handleClick}
                selectedKeys={[transferType]}
                mode="horizontal"
                inlineIndent={0}
            >
                <Menu.Item key={INTERNAL_TRANSFER_TYPE.AGENT}>Agent</Menu.Item>
                <Menu.Item key={INTERNAL_TRANSFER_TYPE.QUEUE}>Queue</Menu.Item>
            </Menu>

            {transferType == INTERNAL_TRANSFER_TYPE.AGENT && <AgentInternalTransfer />}
            {transferType == INTERNAL_TRANSFER_TYPE.QUEUE && <QueueInternalTransfer />}
        </>
    );
}
